import { useEffect, useRef } from 'react';
import { Box } from '@gemini/core';

const Animation = ({
    data,
    name,
    loop = true,
    autoplay = true,
    goToLastFrame = false,
}: {
    data: any;
    name: string;
    loop?: boolean;
    autoplay?: boolean;
    goToLastFrame?: boolean;
}) => {
    const elementRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        import(/* webpackChunkName 'lottie-web'*/ 'lottie-web').then(({ default: lottie }) => {
            if (elementRef.current) {
                const animation = lottie.loadAnimation({
                    container: elementRef.current,
                    name,
                    renderer: 'svg',
                    loop,
                    autoplay,
                    animationData: data,
                });
                if (goToLastFrame) {
                    animation.goToAndStop(animation.getDuration(true), true, name);
                }
            }
        });
    }, []);

    return <Box testId={`${name}-animation-container`} ref={elementRef} />;
};

export default Animation;
